// extracted by mini-css-extract-plugin
export default {"root":"Reviews__root--hCIbE"};